import React, { useRef } from "react";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { DescribedRadioGroup } from "component/shared/described-radio-group";
import { PlatformChoice } from "type/platform-choice";
import { PlatformIcon } from "../platform-icon";
import { styles } from "./style";

interface OwnProps {
	value: PlatformChoice;
	onChange: (value: PlatformChoice) => void;
	"aria-labelledby"?: string;
	/**
	 * Content rendered directly under an option, e.g. the Set Up IDX wizard's Wix App Market notice
	 * (VPLAT 13). The option's radio is described by it.
	 */
	after?: (choice: PlatformChoice) => React.ReactNode;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

/** WordPress / Wix / Other, each with its mark (decision V3; VPLAT 7, 16), on the shared DescribedRadioGroup. */
const Component: React.FC<Props> = ({ classes = {}, value, onChange, "aria-labelledby": ariaLabelledBy, after }) => {
	const name = useRef(`platform-radio-${Math.random().toString(36).slice(2)}`).current;
	return (
		<DescribedRadioGroup
			name={name}
			value={value.id}
			options={PlatformChoice.values().map((choice) => ({
				value: choice.id,
				label: choice.label,
				icon: <PlatformIcon choice={choice} />,
				after: after?.(choice),
			}))}
			onChange={(id) => {
				const choice = PlatformChoice.getById(String(id));
				if (choice) {
					onChange(choice);
				}
			}}
			aria-labelledby={ariaLabelledBy}
			classes={{ title: classes.title }}
		/>
	);
};

export const PlatformRadioGroup = withStyles(Component, styles);
